module.exports = __webpack_public_path__ + "img/2.3310d284.png";